import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RafComponent } from "./raf.component";

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: RafComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RafRoutingModule { }